import { Link, Outlet } from "@tanstack/react-router";
import { useSignOut } from "@empite/session";
import { Button } from "@empite/ui-components";
import { useViewer } from "../marketplace-hooks";
import { SIGN_IN_URL } from "./common";

/**
 * The shell every screen renders inside.
 *
 * Signing OUT is offered here, but signing IN is a link to the account
 * portal: ending a session is the same action in every application of the
 * suite, while starting one belongs to the portal that owns the password.
 */
export function Layout() {
  const viewer = useViewer();
  const signOut = useSignOut();

  return (
    <div className="esm-app">
      <nav className="esm-nav">
        <Link to="/" className="esm-nav__brand">
          Empite Marketplace
        </Link>
        <div className="esm-nav__links">
          <Link to="/">Browse</Link>
          {viewer.signedIn ? (
            <>
              <Link to="/mine">My creations</Link>
              <Link to="/upload">Upload</Link>
              <Button variant="ghost" busy={signOut.isPending} onClick={() => signOut.mutate()}>
                Sign out
              </Button>
            </>
          ) : viewer.ready ? (
            <a href={SIGN_IN_URL}>Sign in</a>
          ) : null}
        </div>
      </nav>
      <main className="esm-main">
        <Outlet />
      </main>
    </div>
  );
}
